/**
 * Thumbnail to Grid Scroll Sync
 * 
 * Synchronizes thumbnail clicks with grid item scroll behavior.
 * When a thumbnail is clicked, scrolls to the corresponding grid item.
 */

class ThumbnailGridScroll {
  constructor() {
    this.init();
  }

  init() {
    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.attachListeners());
    } else {
      this.attachListeners();
    }
  }

  attachListeners() {
    // Find the media gallery container
    const mediaGallery = document.querySelector('media-gallery');
    
    if (!mediaGallery) return;

    // Find all thumbnail items
    const thumbnails = mediaGallery.querySelectorAll('.tumbnals-list__item');
    
    if (!thumbnails.length) return;

    // Find the grid container
    const gridContainer = mediaGallery.querySelector('.media-gallery__grid');
    
    if (!gridContainer) return;

    // Attach click listeners to each thumbnail
    thumbnails.forEach((thumbnail) => {
      thumbnail.addEventListener('click', (e) => {
        this.handleThumbnailClick(e, gridContainer);
      });
    });
  }

  handleThumbnailClick(event, gridContainer) {
    // Get the data-index from the clicked thumbnail
    const index = event.currentTarget.getAttribute('data-index');
    
    if (!index) return;

    // Find the corresponding grid item with the same data-index
    const gridItem = gridContainer.querySelector(`li[data-index="${index}"]`);
    
    if (!gridItem) return;

    // Scroll the grid item into view smoothly
    gridItem.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'nearest',
    });
  }
}

// Initialize the scroll sync
new ThumbnailGridScroll();
